import React from 'react';
import './Fields.scss';
import cn from 'classnames'

export interface IItem {
    title: string;
    key: string;
    description?: string;
    onClick: () => void;
    isAddItem?: boolean;
}

export const FileItem: React.FC<IItem> = (props) => {
    return (<div className={cn('file-field__item', { 'new': props.isAddItem })} key={props.key} onClick={props.onClick}>
        <div>
            <div className='file-filed__fileName'>{props.title}</div>
            {props.description && <div className='file-field__status'>{props.description}</div>}
        </div>
        <div className='file-field__actions'>
            {props.isAddItem && <img src={process.env.PUBLIC_URL + '/icons/Attach.svg'} />}
        </div>
    </div >)
}